:host {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}

.wrapper {
  padding-top: calc(var(--spacer) * 2.5);
  padding-right: calc(var(--spacer) * 2.5);
  width: 100%;
  height: calc(100% - calc(var(--spacer) * 7));
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  position: relative;

  .navigation-header {
    width: 100%;
    padding-bottom: calc(5 * var(--spacer));
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }
}

.title-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-direction: row;
  margin-bottom: calc(var(--spacer));

  gz-title {
    width: fit-content;
  }

  .module-name {
    align-items: center;

    gz-form-field {
      --margin-bottom-wrapper: 0;
    }

    gz-toggle {
      --margin-vertical: 0;
      width: fit-content;
    }

    .content {
      span {
        font-size: var(--card-section-title);
        font-weight: 500;
      }
    }
  }

  .module-link {
    text-align: right;
    align-items: center;
    display: flex;

    .support-link {
      white-space: nowrap;
    }
  }
}

.toggle-subtitle {
  --margin-vertical: 0;
  span {
    font-size: calc(18px + var(--dynamic-font-size-changer));
    font-weight: 500;
  }
}

gz-policy-panel-accordion-buttons {
  width: 100%;
  height: fit-content;
  position: absolute;
  bottom: 0;
  left: 0;

  &.use-ext-js-version {
    display: none;
  }
}

.module-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer) * 2);
  font-weight: 500;
  font-size: 18px;
  width: fit-content;
}

.checkbox-subtitle {
  --font-size: calc(11px + var(--dynamic-small-font-size-changer));
  font-weight: 600;
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

.checkbox-title {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer) * 2);
  --font-size: calc(18px + var(--dynamic-font-size-changer));
  font-weight: 500;
}

.width-60 {
  width: 60%;
}

.width-70 {
  width: 70%;
}

.width-80 {
  width: 80%;
}

.width-100 {
  width: 100%;
}

.infoText {
  color: var(--body-text-arrows-400);
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    width: var(--form-field-label-width);
  }
  .checkbox-width-240 {
    width: 240px;
  }
  .checkbox-width-250 {
    width: 250px;
  }
}

.content-header-toggle {
  span {
    font-size: var(--card-section-title);
    font-weight: 500;
  }
}

.content-title-toggle {
  width: fit-content;
  --margin-vertical: 0px;
  margin-bottom: 0px;
  span {
    font-size: var(--dialog-title-font-size);
    font-weight: 500;
  }
}

gz-checkbox {
  width: auto;
  color: var(--main-titles-inputs-600);
}

gz-toggle, gz-radio {
  width: fit-content;
}

gz-selection-card-group {
  max-width: 1072px;
}

gz-text {
  max-width: 886px;
}

gz-info-box {
  padding: 0px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
  --grid-slot-pointer-events: none;
  --tooltip-pointer-event: none;
}

$size: '0', '1';
@each $marginBottomWrapper in $size {
  .mbw-#{$marginBottomWrapper} {
    --margin-bottom-wrapper: calc(var(--spacer) * #{$marginBottomWrapper});

    gz-toggle {
      --margin-vertical: 0px;
    }
  }
}

gz-form-field[searchable-label] {
  --margin-bottom-wrapper: calc(var(--spacer) * 0.5);
  margin-bottom: calc(var(--spacer) * 1.5);
  width: fit-content;
}

gz-title[searchable-label] {
  width: fit-content;
}

gz-text[searchable-label] {
  width: fit-content;
}

gz-info-box[searchable-label] {
  width: fit-content;
}

.fit-content {
  width: fit-content;
}

.display-flex {
  display: flex;
}
